const crypto = {
  secret: "apm",
};

export default crypto;
